<template>
  <div class="rating-speed-hundred-user-card">
    <div class="rating-speed-hundred-user-card__data">
      <div class="rating-speed-hundred-user-card__data-item">
        <div class="rating-speed-hundred-user-card__data-text">
          <b>{{ user.name }} ( id-{{ user.lmsUserId }} )</b>
        </div>
        <div class="rating-speed-hundred-user-card__data-text">
          <Icon
            class="rating-speed-hundred-user-card__data-icon"
            icon="mail"
          />{{ user.email }}
        </div>
        <div class="rating-speed-hundred-user-card__data-text">
          <Icon
            class="rating-speed-hundred-user-card__data-icon"
            icon="phone"
          />{{ user.phone }}
        </div>
        <div class="rating-speed-hundred-user-card__data-text">
          <Icon
            class="rating-speed-hundred-user-card__data-icon"
            icon="maps-and-flags"
          />{{ user.city }}
        </div>
      </div>
      <div class="rating-speed-hundred-user-card__data-item">
        <div class="rating-speed-hundred-user-card__data-text">
          <span class="rating-speed-hundred-user-card__data-text -grey-"
            >Факультет:</span
          >
          {{ user.facultyName }}
        </div>
        <div class="rating-speed-hundred-user-card__data-text">
          <span class="rating-speed-hundred-user-card__data-text -grey-"
            >Капитан:</span
          >
          {{ user.captainName }}
        </div>
        <div class="rating-speed-hundred-user-card__data-text">
          <span class="rating-speed-hundred-user-card__data-text -grey-"
            >Просмотрено уроков:</span
          >
          {{ user.lessonViews }}
        </div>
      </div>
      <div class="rating-speed-hundred-user-card__data-item">
        <div
          v-if="user.responsiblePartnerName"
          class="rating-speed-hundred-user-card__data-text"
        >
          <span class="rating-speed-hundred-user-card__data-text -grey-"
            >Ответственный партнер:</span
          >
          {{ user.responsiblePartnerName }}
        </div>
        <div
          v-if="user.addedBy"
          class="rating-speed-hundred-user-card__data-text"
        >
          <span class="rating-speed-hundred-user-card__data-text -grey-"
            >Добавил:</span
          >
          {{ user.addedBy }}
        </div>
        <a
          v-if="user.amoLeadId"
          :href="
            'https://likebusiness.amocrm.ru/leads/detail/' + user.amoLeadId
          "
          target="_blank"
        >
          <Icon
            v-if="user.amoLeadId"
            class="rating-speed-hundred-user-card__data-button"
            icon="amocrm-link"
          />
        </a>
      </div>
    </div>
    <div class="rating-speed-hundred-user-card__table">
      <MetricsTable
        class="speed-hundred-user-card"
        :traction-data="tractionData"
        :traction-metrics="tractionTypes"
        :show-tooltip="false"
        :can-select-course="false"
        :can-edit="false"
        :style="{ zIndex: 'unset' }"
      />
    </div>
  </div>
</template>

<script>
import Cell from '../../components/Table/Cell';
import Row from '../../components/Table/Row';
import Table from '../../components/Table/';
import NavCell from '../../components/Table/NavCell';
import MetricsTable from '../../Unified/User/components/MetricsTable';
import numberFormat from '@/filters/numberFormat.filter';
import { mapState } from 'vuex';
import {
  processCoursesList,
  filterMetrics,
  mapTraction
} from '@/store/rating/unified/createTractionTimeline';

export default {
  components: {
    Cell,
    Row,
    Table,
    NavCell,
    MetricsTable
  },
  props: {
    user: {},
    values: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tractionData: []
    };
  },
  computed: {
    ...mapState('ratingSpeedAndHundred', {
      courseStreams: s => s.data.courseStreams,
      currentStream: s => s.data.currentStream,
      tractionTypes: s => s.data.tractionTypes
    }),
    navTitles() {
      const titles = [
        {
          id: 0,
          title: 'Метрики',
          width: '1fr'
        }
      ];

      for (const [key, value] of Object.entries(this.user.revenue)) {
        titles.push(key);
        titles[key] = {
          title: key,
          id: parseInt(key),
          width: '1fr'
        };
      }

      return titles;
    }
  },
  created() {
    const processedCourses = processCoursesList([this.currentStream]);
    const filteredMetrics = filterMetrics(this.tractionTypes, processedCourses);
    this.tractionData = mapTraction(this.values, filteredMetrics);
  },
  methods: {
    getFormattedValue(value) {
      return numberFormat(value, this.noDot);
    }
  }
};
</script>
